<template>
  <div>
    <div v-if="howmany==0">
        <font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/>
    </div>
    <div v-if="howmany==1">
        <font-icon :icon="['fa', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/>
    </div>
    <div v-if="howmany==2">
        <font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/>
    </div>
    <div v-if="howmany==3">
        <font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['far', 'circle']"/><font-icon :icon="['far', 'circle']"/>
    </div>
    <div v-if="howmany==4">
        <font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['far', 'circle']"/>
    </div>
    <div v-if="howmany==5">
        <font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/><font-icon :icon="['fa', 'circle']"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    howmany: 0
  }
};
</script>

<style scoped>
.fa-circle{
  margin: 0 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/Rating.vue